import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/providers/#webpage",
   "url": "https://www.futurefamilyai.com/providers/",
   "name": "Remote Pregnancy Monitoring for Physicians | FutureFamilyAI",
   "description": "Give your OB patients a structured home BP and wellness program with clearly labeled trends and human review at Orange and Red. Request a clinical demo.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "EMR Integration",
     "item": "https://www.futurefamilyai.com/providers/emr-integration/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "For Physicians",
     "item": "https://www.futurefamilyai.com/providers/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "How does remote blood pressure monitoring work for pregnant patients?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Patients take readings at home with a validated cuff on the schedule you set. Readings sync to the app, are compared with your thresholds, and patterns needing attention are reviewed by people."
     }
    },
    {
     "@type": "Question",
     "name": "Is FutureFamilyAI a medical device?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. It is positioned as a wellness and awareness tool, is not FDA-cleared and does not diagnose. It supports, rather than replaces, your clinical judgment."
     }
    },
    {
     "@type": "Question",
     "name": "Who responds to an Orange or Red status?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "A care-team member reviews the pattern and follows the escalation steps agreed with the treating practice. Your practice remains responsible for clinical decisions."
     }
    },
    {
     "@type": "Question",
     "name": "Does it integrate with Epic?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Epic connectivity is described as available only after technical and contractual verification for your organization. Request the current integration status during a demo."
     }
    },
    {
     "@type": "Question",
     "name": "What does it cost a practice?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "There is no fee for practices to recommend FutureFamilyAI. Patients join the free pilot through December 31, 2026."
     }
    },
    {
     "@type": "Question",
     "name": "Can I customize thresholds?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Thresholds and escalation instructions follow the treating clinician's plan within the protocol framework. Specifics are confirmed during onboarding."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function ProvidersPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/providers/emr-integration">EMR Integration</Link>
              <span>›</span>
              <span>For Physicians</span>
            </nav>
            <div className="topvideo_section">
              <div className=" row">
                <div className=" col-md-6">
                  {/* <span className="ffh-eyebrow">Physician-connected pregnancy wellness</span> */}
                  <h1>
                    Connected Care for Better Pregnancy Monitoring
                  </h1>

                  <p className="ffh-lead speakable-content">
                    Empower your care team with patient wellness trends, blood pressure monitoring insights, and care-team-reviewed alerts. FutureFamilyAI supports communication and care coordination throughout pregnancy, surrogacy, and postpartum recovery.
                  </p>
                  <p style={{ fontSize: "1.25rem", fontWeight: "700", color: "var(--blue-ink)" }}>
                    Better Visibility. Connected Patients. Coordinated Care.
                  </p>
                  <div class="ffh-cta-row">
                    <a class="ffh-btn ffh-primary" href="#">Download the App </a>
                    <a class="ffh-btn ffh-ghost" href="/contact-us?type=member" data-discover="true">Explore How It Works</a>
                  </div>

                </div>
                <div className="col-md-6" aria-label="Example FutureFamilyAI app screen (illustrative)">
                  <iframe
                    width="100%"
                    height="365"
                    src="https://www.youtube.com/embed/9Rc0FahoZ70?rel=0"
                    title="Pregnancy Monitoring Between Visits | FutureFamilyAI for OB Providers"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                FutureFamilyAI gives physicians a structured way to see what
                happens between prenatal visits: validated-cuff blood pressure,
                wearable trends and symptom reports, organized and clearly
                labeled.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Physicians &amp; OB providers</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      The USPSTF recommends screening for hypertensive disorders
                      of pregnancy with blood pressure measurements throughout
                      pregnancy. (USPSTF, 2023)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Validated-cuff BP — not wrist estimates ·
                      Human-in-the-loop escalation · Patient-controlled consent,
                      documented
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact-us/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">FOR PHYSICIANS &amp; OB TEAMS</span>
            <h1>Remote Pregnancy Monitoring for Physicians and OB Teams</h1>
            <p className="ffh-answer speakable-content">
              FutureFamilyAI gives physicians a structured way to see what
              happens between prenatal visits: validated-cuff blood pressure,
              wearable trends and symptom reports, organized and clearly
              labeled. Orange and Red statuses are reviewed by a care team
              following a protocol informed by ACOG, SMFM, ISSHP and AHA
              guidance. It is an adjunct to your workflow, not a replacement for
              clinical judgment. Request a clinical demo.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=physician"
              >
                Request a Clinical Demo
              </Link>
              <Link
                className="ffh-btn ffh-ghost"
                to="/partners/join-referral-network"
              >
                Join the Partner Network — No Fees
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Obstetrician reviewing a patient's home blood pressure trends between visits"
              >
                <img
                  src="/images/obstetrician.jpg"
                  alt="Obstetrician reviewing a patient&apos;s home blood pressure trends between visits" />

              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    The USPSTF recommends screening for hypertensive disorders
                    of pregnancy with blood pressure measurements throughout
                    pregnancy.
                    <cite>
                      Source:{" "}
                      <a href="https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/hypertensive-disorders-pregnancy-screening">
                        USPSTF, 2023
                      </a>
                    </cite>
                  </li>
                  <li>
                    Patient-generated health data is health-related data
                    created, recorded or gathered by patients to help address a
                    health concern.
                    <cite>
                      Source:{" "}
                      <a href="https://www.healthit.gov/topic/scientific-initiatives/pcor/patient-generated-health-data-pghd">
                        ONC / HealthIT.gov
                      </a>
                    </cite>
                  </li>
                  <li>
                    ACOG recommends a blood pressure check no later than 7–10
                    days after delivery for people with hypertensive disorders
                    of pregnancy, and within 72 hours for severe hypertension.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/committee-opinion/articles/2018/05/optimizing-postpartum-care">
                        ACOG Committee Opinion No. 736, 2018
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>The data you already wish you had</h2>
                <p>
                  Home readings sent by text or photo are hard to trust and
                  harder to file. FutureFamilyAI delivers time-stamped cuff
                  readings, symptoms reported at the time of measurement and
                  context from sleep and activity trends — in one view.
                </p>
              </section>
              <section id="s2">
                <h2>Designed around clinical judgment</h2>
                <ul>
                  <li>
                    Members see a color status only — no numeric risk score.
                  </li>
                  <li>Orange and Red patterns trigger human review.</li>
                  <li>
                    Thresholds and escalation steps follow the treating
                    clinician&apos;s plan.
                  </li>
                  <li>
                    Not real-time and not an emergency channel — patients are
                    instructed accordingly.
                  </li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>No partner fees. Our care team handles patient setup.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=physician"
                >
                  Request a Clinical Demo
                </Link>
              </div>
              <section id="s3">
                <h2>Low burden for your practice</h2>
                <p>
                  The care team handles enrollment support, device questions and
                  reminders. You choose which patients to invite and which
                  summaries your practice reviews.
                </p>
              </section>
              <section id="s4">
                <h2>Integration</h2>
                <p>
                  Trend reports can be shared today as summaries. EMR
                  connectivity, including Epic, is available only where it has
                  been technically and contractually verified — ask for the
                  current integration matrix during your demo.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      How does remote blood pressure monitoring work for
                      pregnant patients?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Patients take readings at home with a validated cuff on
                        the schedule you set. Readings sync to the app, are
                        compared with your thresholds, and patterns needing
                        attention are reviewed by people.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is FutureFamilyAI a medical device?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        No. It is positioned as a wellness and awareness tool,
                        is not FDA-cleared and does not diagnose. It supports,
                        rather than replaces, your clinical judgment.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Who responds to an Orange or Red status?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        A care-team member reviews the pattern and follows the
                        escalation steps agreed with the treating practice. Your
                        practice remains responsible for clinical decisions.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Does it integrate with Epic?</summary>
                    <div className="ffh-ans">
                      <p>
                        Epic connectivity is described as available only after
                        technical and contractual verification for your
                        organization. Request the current integration status
                        during a demo.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>What does it cost a practice?</summary>
                    <div className="ffh-ans">
                      <p>
                        There is no fee for practices to recommend
                        FutureFamilyAI. Patients join the free pilot through
                        December 31, 2026.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can I customize thresholds?</summary>
                    <div className="ffh-ans">
                      <p>
                        Thresholds and escalation instructions follow the
                        treating clinician&apos;s plan within the protocol
                        framework. Specifics are confirmed during onboarding.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=physician"
                  >
                    Request a Clinical Demo
                  </Link>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/partners/join-referral-network"
                  >
                    Join the Partner Network — No Fees
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">RG</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Rashmi Gulati, MD</h3>
                  <p>
                    Medical Director, Patients Medical. Dr. Rashmi Gulati, MD,
                    is Medical Director of Patients Medical, a Manhattan
                    practice founded in 1974. She leads FutureFamilyAI&apos;s
                    physician and care-team content and medically reviews every
                    page on this site.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/providers/emr-integration">EMR Integration →</Link>
                  <Link to="/providers/epic-integration-patient-generated-data">
                    Epic Patient-Generated Data →
                  </Link>
                  <Link to="/providers/physician-dashboard-pregnancy-monitoring">
                    Physician Dashboard →
                  </Link>
                  <Link to="/providers/how-to-recommend-future-family">
                    Recommend FutureFamilyAI →
                  </Link>
                  <Link to="/providers/clinical-protocol-acog-smfm">
                    Clinical Protocol →
                  </Link>
                  <Link to="/providers/emr-systems-supported">
                    Supported EMR Systems →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.patientsmedical.com">
                    https://www.patientsmedical.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">The data you already wish you had</a>
                  </li>
                  <li>
                    <a href="#s2">Designed around clinical judgment</a>
                  </li>
                  <li>
                    <a href="#s3">Low burden for your practice</a>
                  </li>
                  <li>
                    <a href="#s4">Integration</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Partner with FutureFamilyAI</b>
                <span>No fees. Free directory listing.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=physician"
                >
                  Request a Clinical Demo
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
